import { useRentalUnitField } from '../../../../../../../../queries/useRentalUnitField';
import { NumberBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../../components/ApplicationQuestionReviewItem';
import { ShowIf } from '../../../../../../../components/ShowIf';

interface GarageBaysProps {
    unitGuid: string;
    required: boolean;
    isReview?: boolean;
    showLabel?: boolean;
}

export const GarageBays: React.FC<GarageBaysProps> = ({ unitGuid, required, isReview = false, showLabel = false }) => {
    const label = 'Garage Bays';
    const [garageBays, set_garageBays] = useRentalUnitField(
        unitGuid,
        (u) => u.garageBays,
        (u, v) => ({ ...u, garageBays: v })
    );

    return (
        <>
            {isReview ? (
                <>
                    <ShowIf showIf={showLabel}>
                        <ApplicationQuestionReviewItem
                            label={label}
                            value={garageBays}
                            showLabel={showLabel}
                        />
                    </ShowIf>
                    <ShowIf showIf={!showLabel}>{garageBays}</ShowIf>
                </>
            ) : (
                <NumberBox
                    id={`garageBays_${unitGuid}`}
                    value={garageBays}
                    onChange={(value) => set_garageBays(value)}
                    required={required}
                    label={showLabel ? label : undefined}
                    format='#0'
                />
            )}
        </>
    );
};
